module.exports = __webpack_public_path__ + "img/1首页产品图-五金.fb645661.png";